import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import LockIcon from '@mui/icons-material/Lock'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Modal from '../../shared/Modal'

import {connect} from '../../../state/hooks/tools'
import {updateResource} from '../../../lib/asyncMethods'
import {DISABLED, TFA_BYPASS} from '../../../lib/featureFlags'
import {SETTINGS} from '../../../state/actionTypes'

/**
 * Switching the bypass off is not a return to a second factor — the account has none to be asked
 * for, so the sign-in dead-ends instead. The dialog is titled by that outcome rather than by the
 * field being changed, and says nothing the person on the other end would be told: the notice they
 * reach keeps the reason to itself on purpose.
 */
const DisableBypass = props => {
  const disable = () => {
    props.updateResource({endpoint: `settings/${props.flag.id}`, attributes: {value: DISABLED}}).then(response => {
      if (response.success)
        props.toggleModal()
    })
  }

  return (
    <Modal
      open={props.showModal}
      handleClose={props.toggleModal}
      disabled={props.loading}
      maxWidth='sm'
      buttonText='Cancel'
      title={`Lock ${props.holderName} out?`}>
        <Stack className='disable-bypass'>
          <Typography gutterBottom>
            Switching {TFA_BYPASS} off does not put this account back on 2FA. It has no second factor to
            fall back on, so sign-in stops at a notice telling them to contact an administrator.
          </Typography>
          <Stack className='transition' direction='row'>
            <Chip size='small' color='primary' label='Enabled' />
            <ChevronRightIcon color='disabled' />
            <Chip size='small' color='error' label='Locked out' />
          </Stack>
          <Alert className='notice' severity='error' icon={<LockIcon />}>
            They cannot get themselves back in. Only an admin switching this flag on again restores
            access — and because the grant can never be moved, it has to be this account.
          </Alert>
          <Button disabled={props.loading} onClick={disable} variant='contained' color='error'>
            Disable
          </Button>
        </Stack>
    </Modal>
  )
}

const mapStateToProps = ({metadata}) => ({loading: metadata.loading})

const actionCreators = ({metadata}) => ({updateResource: updateResource(metadata, SETTINGS)})

export default connect(mapStateToProps, actionCreators)(DisableBypass)
